import { observer } from "mobx-react-lite"
import { RowStyled, VolumeLevelStyled } from "./Row.styled"
import { FC, useMemo } from "react"

type TPercent = number

interface IRow {
    price: number
    volume: string
    color: string
    width: TPercent
}

const Row: FC<IRow> = observer(({price, volume, color, width}) => {
  const transformedPrice = useMemo(() => {
    return makeNumber(price)
  }, [price])

  return (
    <RowStyled>
      <p style={{ color}}>{transformedPrice}</p>
      <p style={{ color}}>{volume}</p>
      <VolumeLevelStyled
        style={{
          backgroundColor: color,
          width: `${width}%`,
        }}
      />
    </RowStyled>
  )
})

function makeNumber(number: number) {
  const digits = 6

  while (!(number < 10**digits && number >= 10**(digits-1))) {
    if (number < 10**(digits-1)) {
      number = number * 10
    }
    if (number >= 10**digits) {
      number = number / 10
    }
  }

  return Math.round(number)
}

export default Row